module.exports = __webpack_public_path__ + "img/download_pdficon_disabled.c743450a.svg";